module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-blog-5-e7d9559d76b7975bd11218ece26be3d6.jpg";